const allCountries = [
  [
    'Afghanistan',
    'af',
    '93'
  ],
  [
    'Albanie',
    'al',
    '355'
  ],
  [
    'Algérie',
    'dz',
    '213'
  ],
  [
    'Samoa',
    'as',
    '1684'
  ],
  [
    'Andorre',
    'ad',
    '376'
  ],
  [
    'Angola',
    'ao',
    '244'
  ],
  [
    'Anguilla',
    'ai',
    '1264'
  ],
  [
    'Antigua-et-Barbuda',
    'ag',
    '1268'
  ],
  [
    'Argentine',
    'ar',
    '54'
  ],
  [
    'Arménie',
    'am',
    '374'
  ],
  [
    'Aruba',
    'aw',
    '297'
  ],
  [
    'Australie',
    'au',
    '61',
    0
  ],
  [
    'Autriche',
    'at',
    '43'
  ],
  [
    'Azerbaïdjan',
    'az',
    '994'
  ],
  [
    'Bahamas',
    'bs',
    '1242'
  ],
  [
    'Bahreïn',
    'bh',
    '973'
  ],
  [
    'Bangladesh',
    'bd',
    '880'
  ],
  [
    'Barbade',
    'bb',
    '1246'
  ],
  [
    'Bélarus',
    'by',
    '375'
  ],
  [
    'Belgique',
    'be',
    '32'
  ],
  [
    'Bélize',
    'bz',
    '501'
  ],
  [
    'Bénin',
    'bj',
    '229'
  ],
  [
    'Les Bermudes',
    'bm',
    '1441'
  ],
  [
    'Bhoutan',
    'bt',
    '975'
  ],
  [
    'Bolivie',
    'bo',
    '591'
  ],
  [
    'Bosnie-Herzégovine',
    'ba',
    '387'
  ],
  [
    'Botswana',
    'bw',
    '267'
  ],
  [
    'Brésil',
    'br',
    '55'
  ],
  [
    'Territoire britannique de l\'océan Indien',
    'io',
    '246'
  ],
  [
    'Îles Vierges britanniques',
    'vg',
    '1284'
  ],
  [
    'Brunei',
    'bn',
    '673'
  ],
  [
    'Bulgarie',
    'bg',
    '359'
  ],
  [
    'Burkina Faso',
    'bf',
    '226'
  ],
  [
    'Burundi',
    'bi',
    '257'
  ],
  [
    'Cambodge',
    'kh',
    '855'
  ],
  [
    'Cameroun',
    'cm',
    '237'
  ],
  [
    'Canada',
    'ca',
    '1',
    1,
    ['204', '226', '236', '249', '250', '289', '306', '343', '365', '387', '403', '416', '418', '431', '437', '438', '450', '506', '514', '519', '548', '579', '581', '587', '604', '613', '639', '647', '672', '705', '709', '742', '778', '780', '782', '807', '819', '825', '867', '873', '902', '905']
  ],
  [
    'Cap-Vert',
    'cv',
    '238'
  ],
  [
    'Pays-Bas caribéens',
    'bq',
    '599',
    1
  ],
  [
    'Îles Caïmans',
    'ky',
    '1345'
  ],
  [
    'République centrafricaine',
    'cf',
    '236'
  ],
  [
    'Tchad',
    'td',
    '235'
  ],
  [
    'Chili',
    'cl',
    '56'
  ],
  [
    'Chine',
    'cn',
    '86'
  ],
  [
    'Île Christmas',
    'cx',
    '61',
    2
  ],
  [
    'Îles Cocos',
    'cc',
    '61',
    1
  ],
  [
    'Colombie',
    'co',
    '57'
  ],
  [
    'Comores',
    'km',
    '269'
  ],
  [
    'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    'cd',
    '243'
  ],
  [
    'République démocratique du Congo',
    'cg',
    '242'
  ],
  [
    'Îles Cook',
    'ck',
    '682'
  ],
  [
    'Costa Rica',
    'cr',
    '506'
  ],
  [
    'Côte d’Ivoire',
    'ci',
    '225'
  ],
  [
    'Croatie',
    'hr',
    '385'
  ],
  [
    'Cuba',
    'cu',
    '53'
  ],
  [
    'Curaçao',
    'cw',
    '599',
    0
  ],
  [
    'Chypre',
    'cy',
    '357'
  ],
  [
    'République tchèque',
    'cz',
    '420'
  ],
  [
    'Danemark',
    'dk',
    '45'
  ],
  [
    'Djibouti',
    'dj',
    '253'
  ],
  [
    'Dominique',
    'dm',
    '1767'
  ],
  [
    'République dominicaine',
    'do',
    '1',
    2,
    ['809', '829', '849']
  ],
  [
    'Équateur',
    'ec',
    '593'
  ],
  [
    'Égypte',
    'eg',
    '20'
  ],
  [
    'Le Salvador',
    'sv',
    '503'
  ],
  [
    'Guinée équatoriale',
    'gq',
    '240'
  ],
  [
    'Érythrée',
    'er',
    '291'
  ],
  [
    'Estonie',
    'ee',
    '372'
  ],
  [
    'Éthiopie',
    'et',
    '251'
  ],
  [
    'Îles Falkland (Îles Malouines)',
    'fk',
    '500'
  ],
  [
    'Îles Féroé',
    'fo',
    '298'
  ],
  [
    'Fidji',
    'fj',
    '679'
  ],
  [
    'Finlande',
    'fi',
    '358',
    0
  ],
  [
    'France',
    'fr',
    '33'
  ],
  [
    'Guyane française',
    'gf',
    '594'
  ],
  [
    'Polynésie française',
    'pf',
    '689'
  ],
  [
    'Gabon',
    'ga',
    '241'
  ],
  [
    'Gambie',
    'gm',
    '220'
  ],
  [
    'Géorgie',
    'ge',
    '995'
  ],
  [
    'Allemagne',
    'de',
    '49'
  ],
  [
    'Ghana',
    'gh',
    '233'
  ],
  [
    'Gibraltar',
    'gi',
    '350'
  ],
  [
    'Grèce',
    'gr',
    '30'
  ],
  [
    'Groenland',
    'gl',
    '299'
  ],
  [
    'Grenade',
    'gd',
    '1473'
  ],
  [
    'Guadeloupe',
    'gp',
    '590',
    0
  ],
  [
    'Guam',
    'gu',
    '1671'
  ],
  [
    'Guatemala',
    'gt',
    '502'
  ],
  [
    'Guernsey',
    'gg',
    '44',
    1
  ],
  [
    'Guinée',
    'gn',
    '224'
  ],
  [
    'Guiné Bissau',
    'gw',
    '245'
  ],
  [
    'Guyana',
    'gy',
    '592'
  ],
  [
    'Haïti',
    'ht',
    '509'
  ],
  [
    'Honduras',
    'hn',
    '504'
  ],
  [
    'Hong Kong',
    'hk',
    '852'
  ],
  [
    'Hongrie',
    'hu',
    '36'
  ],
  [
    'Islande',
    'is',
    '354'
  ],
  [
    'Inde',
    'in',
    '91'
  ],
  [
    'Indonésie',
    'id',
    '62'
  ],
  [
    'Iran',
    'ir',
    '98'
  ],
  [
    'Iraq',
    'iq',
    '964'
  ],
  [
    'Irlande',
    'ie',
    '353'
  ],
  [
    'Île de Man',
    'im',
    '44',
    2
  ],
  [
    'Israël',
    'il',
    '972'
  ],
  [
    'Italie',
    'it',
    '39',
    0
  ],
  [
    'Jamaïque',
    'jm',
    '1876'
  ],
  [
    'Japon',
    'jp',
    '81'
  ],
  [
    'Jersey',
    'je',
    '44',
    3
  ],
  [
    'Jordanie',
    'jo',
    '962'
  ],
  [
    'Kazakhstan',
    'kz',
    '7',
    1
  ],
  [
    'Kenya',
    'ke',
    '254'
  ],
  [
    'Kiribati',
    'ki',
    '686'
  ],
  [
    'Kosovo',
    'xk',
    '383'
  ],
  [
    'Koweït',
    'kw',
    '965'
  ],
  [
    'Kirghizistan',
    'kg',
    '996'
  ],
  [
    'Laos',
    'la',
    '856'
  ],
  [
    'Lettonie',
    'lv',
    '371'
  ],
  [
    'Liban',
    'lb',
    '961'
  ],
  [
    'Lesotho',
    'ls',
    '266'
  ],
  [
    'Libéria',
    'lr',
    '231'
  ],
  [
    'Libye',
    'ly',
    '218'
  ],
  [
    'Liechtenstein',
    'li',
    '423'
  ],
  [
    'Lithuanie',
    'lt',
    '370'
  ],
  [
    'Luxembourg',
    'lu',
    '352'
  ],
  [
    'Macao',
    'mo',
    '853'
  ],
  [
    'Macédoine',
    'mk',
    '389'
  ],
  [
    'Madagascar',
    'mg',
    '261'
  ],
  [
    'Malawi',
    'mw',
    '265'
  ],
  [
    'Malaisie',
    'my',
    '60'
  ],
  [
    'Maldives',
    'mv',
    '960'
  ],
  [
    'Mali',
    'ml',
    '223'
  ],
  [
    'Malte',
    'mt',
    '356'
  ],
  [
    'Îles Marshall',
    'mh',
    '692'
  ],
  [
    'Martinique',
    'mq',
    '596'
  ],
  [
    'Mauritanie',
    'mr',
    '222'
  ],
  [
    'Maurice',
    'mu',
    '230'
  ],
  [
    'Mayotte',
    'yt',
    '262',
    1
  ],
  [
    'Mexique',
    'mx',
    '52'
  ],
  [
    'Micronesie',
    'fm',
    '691'
  ],
  [
    'Moldavie',
    'md',
    '373'
  ],
  [
    'Monaco',
    'mc',
    '377'
  ],
  [
    'Mongolie',
    'mn',
    '976'
  ],
  [
    'Monténégro',
    'me',
    '382'
  ],
  [
    'Montserrat',
    'ms',
    '1664'
  ],
  [
    'Maroc',
    'ma',
    '212',
    0
  ],
  [
    'Mozambique',
    'mz',
    '258'
  ],
  [
    'Birmanie',
    'mm',
    '95'
  ],
  [
    'Namibie',
    'na',
    '264'
  ],
  [
    'Nauru',
    'nr',
    '674'
  ],
  [
    'Népal',
    'np',
    '977'
  ],
  [
    'Pays-Bas',
    'nl',
    '31'
  ],
  [
    'Nouvelle-Calédonie',
    'nc',
    '687'
  ],
  [
    'Nouvelle-Zélande',
    'nz',
    '64'
  ],
  [
    'Nicaragua',
    'ni',
    '505'
  ],
  [
    'Niger (Nijar)',
    'ne',
    '227'
  ],
  [
    'Nigéria',
    'ng',
    '234'
  ],
  [
    'Niue',
    'nu',
    '683'
  ],
  [
    'Île Norfolk',
    'nf',
    '672'
  ],
  [
    'Corée du Nord',
    'kp',
    '850'
  ],
  [
    'Îles Mariannes du Nord',
    'mp',
    '1670'
  ],
  [
    'Norvège',
    'no',
    '47',
    0
  ],
  [
    'Oman',
    'om',
    '968'
  ],
  [
    'Pakistan',
    'pk',
    '92'
  ],
  [
    'Palaos',
    'pw',
    '680'
  ],
  [
    'Palestine',
    'ps',
    '970'
  ],
  [
    'Panamá',
    'pa',
    '507'
  ],
  [
    'Papouasie-Nouvelle-Guinée',
    'pg',
    '675'
  ],
  [
    'Paraguay',
    'py',
    '595'
  ],
  [
    'Pérou',
    'pe',
    '51'
  ],
  [
    'Philippines',
    'ph',
    '63'
  ],
  [
    'Pologne',
    'pl',
    '48'
  ],
  [
    'Portugal',
    'pt',
    '351'
  ],
  [
    'Porto Rico',
    'pr',
    '1',
    3,
    ['787', '939']
  ],
  [
    'Qatar',
    'qa',
    '974'
  ],
  [
    'La Réunion',
    're',
    '262',
    0
  ],
  [
    'Roumanie',
    'ro',
    '40'
  ],
  [
    'Russie',
    'ru',
    '7',
    0
  ],
  [
    'Rwanda',
    'rw',
    '250'
  ],
  [
    'Saint Barthélemy',
    'bl',
    '590',
    1
  ],
  [
    'Sainte-Hélène',
    'sh',
    '290'
  ],
  [
    'Saint-Kitts-et-Nevis',
    'kn',
    '1869'
  ],
  [
    'Saint-Lucie',
    'lc',
    '1758'
  ],
  [
    'Saint-Martin (partie française)',
    'mf',
    '590',
    2
  ],
  [
    'Saint Pierre and Miquelon',
    'pm',
    '508'
  ],
  [
    'Saint-Vincent-et-les Grenadines',
    'vc',
    '1784'
  ],
  [
    'Samoa',
    'ws',
    '685'
  ],
  [
    'San Marin',
    'sm',
    '378'
  ],
  [
    'Sao Tomé-et-Principe',
    'st',
    '239'
  ],
  [
    'Arabie Saoudite',
    'sa',
    '966'
  ],
  [
    'Sénégal',
    'sn',
    '221'
  ],
  [
    'Serbie',
    'rs',
    '381'
  ],
  [
    'Seychelles',
    'sc',
    '248'
  ],
  [
    'Sierra Leone',
    'sl',
    '232'
  ],
  [
    'Singapour',
    'sg',
    '65'
  ],
  [
    'Saint-Martin (partie néerlandaise)',
    'sx',
    '1721'
  ],
  [
    'Slovaquie',
    'sk',
    '421'
  ],
  [
    'Slovénie',
    'si',
    '386'
  ],
  [
    'Îles Salomon',
    'sb',
    '677'
  ],
  [
    'Somalie',
    'so',
    '252'
  ],
  [
    'Afrique du Sud',
    'za',
    '27'
  ],
  [
    'Corée du Sud',
    'kr',
    '82'
  ],
  [
    'Soudan du Sud',
    'ss',
    '211'
  ],
  [
    'Espagne',
    'es',
    '34'
  ],
  [
    'Sri Lanka',
    'lk',
    '94'
  ],
  [
    'Soudan',
    'sd',
    '249'
  ],
  [
    'Suriname',
    'sr',
    '597'
  ],
  [
    'Svalbard et Jan Mayen',
    'sj',
    '47',
    1
  ],
  [
    'Swaziland',
    'sz',
    '268'
  ],
  [
    'Suède',
    'se',
    '46'
  ],
  [
    'Suisse',
    'ch',
    '41'
  ],
  [
    'Syrie',
    'sy',
    '963'
  ],
  [
    'Taiwan',
    'tw',
    '886'
  ],
  [
    'Tadjikistan',
    'tj',
    '992'
  ],
  [
    'Tanzanie',
    'tz',
    '255'
  ],
  [
    'Thaïlande',
    'th',
    '66'
  ],
  [
    'Timor-Oriental',
    'tl',
    '670'
  ],
  [
    'Togo',
    'tg',
    '228'
  ],
  [
    'Tokelau',
    'tk',
    '690'
  ],
  [
    'Tonga',
    'to',
    '676'
  ],
  [
    'Trinité-et-Tobago',
    'tt',
    '1868'
  ],
  [
    'Tunisie',
    'tn',
    '216'
  ],
  [
    'Turquie',
    'tr',
    '90'
  ],
  [
    'Turkménistan',
    'tm',
    '993'
  ],
  [
    'Îles Turques-et-Caïques',
    'tc',
    '1649'
  ],
  [
    'Tuvalu',
    'tv',
    '688'
  ],
  [
    'Îles Vierges des États-Unis',
    'vi',
    '1340'
  ],
  [
    'Ouganda',
    'ug',
    '256'
  ],
  [
    'Ukraine',
    'ua',
    '380'
  ],
  [
    'Émirats arabes unis',
    'ae',
    '971'
  ],
  [
    'Royaume-Uni',
    'gb',
    '44',
    0
  ],
  [
    'États-Unis d’Amérique',
    'us',
    '1',
    0
  ],
  [
    'Uruguay',
    'uy',
    '598'
  ],
  [
    'Ouzbékistan',
    'uz',
    '998'
  ],
  [
    'Vanuatu',
    'vu',
    '678'
  ],
  [
    'État de la Cité du Vatican',
    'va',
    '39',
    1
  ],
  [
    'Venezuela',
    've',
    '58'
  ],
  [
    'Vietnam',
    'vn',
    '84'
  ],
  [
    'Wallis-et-Futuna',
    'wf',
    '681'
  ],
  [
    'Sahara occidental',
    'eh',
    '212',
    1
  ],
  [
    'Yémen',
    'ye',
    '967'
  ],
  [
    'Zambie',
    'zm',
    '260'
  ],
  [
    'Zimbabwe',
    'zw',
    '263'
  ],
  [
    'Îles Åland',
    'ax',
    '358',
    1
  ]
]

export const countriesIso = allCountries.map(country => country[1].toUpperCase())

export const countries = allCountries.map(country => ({
  name: country[0],
  iso2: country[1].toUpperCase(),
  dialCode: country[2],
  priority: country[3] || 0,
  areaCodes: country[4] || null
}))
